// extracted by mini-css-extract-plugin
module.exports = {"chart":"style_chart__PTnGX","pieChart":"style_pieChart__3KlbD"};